import {$, T} from "../../common/drupal/drupal";

class ParagraphCocktail {

    /**
     * Initialize event listeners
     */
    init () {
      // slide Paragraph cocktail
      let slideCocktailId = 0;
      let slideCocktails = [];
      $('.ParagraphCocktail-cocktails:not(.swiper-container)').each(function () {
          $(this).addClass('swiper-container').find('.NodeCocktail-paragraph').addClass('swiper-slide').wrapAll('<div class="swiper-wrapper"/>');
          $(this).append('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>');
          slideCocktails[slideCocktailId] = new Swiper($(this), {
              slidesPerView: 'auto',
              speed: 500,
              watchOverflow: true,
              centerInsufficientSlides: true,
              navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
              },
          });
          slideCocktailId++;
      });
    }

    attach(context) {
        this.init(context);
    }
}

export let paragraphCocktail = new ParagraphCocktail();
